import { SocialLoading } from '~/components'
import useSocialProviderRedirect from '~/lib/useSocialProviderRedirect'

export default function AppleLogin() {
  useSocialProviderRedirect('apple')

  return <SocialLoading height={479} />
}
